// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2Gy5H","gfeWrapper":"CalendarEvent_gfeWrapper__2SA8P"};